import {Helmet} from 'react-helmet-async';
import {useTranslation} from 'react-i18next';

const SEO = () => {
  const {i18n} = useTranslation();
  const selectedLanguage = i18n.language;
  const isPt = selectedLanguage.includes('pt');

  const desc = isPt
    ? 'Metalogic. Da concepção à instalação, confie em nossa expertise para estruturas metálicas duráveis e de alta qualidade. Braga.'
    : 'Metalogic. From conception to installation, trust our expertise for durable and high-quality metal structures. Braga.';

  const title = isPt ? 'Metalogic by AR Group' : 'Metalogic by AR Group';

  const keywords = isPt
    ? 'metalogic, construção metálica, construções metálicas, estruturas de aço, serralheria arquitetônica, soluções de construção em metal, obras personalizadas em metal, engenharia de metal, pavilhões agrícolas, hangares de aviação, estruturas metálicas personalizadas, fabricação de estruturas metálicas, soluções industriais em metal, construção de pavilhões metálicos, construção de hangares metálicos, projetos de engenharia metálica, estruturas para indústrias, construção de estruturas metálicas duráveis, braga'
    : 'metalogic, metal construction, metal constructions, steel structures, architectural metalwork, metal construction solutions, custom metalwork, metal engineering, agricultural pavilions, aviation hangars, custom metal structures, metal structures fabrication, industrial metal solutions, metal pavilions construction, aviation hangars construction, metal engineering projects, industrial structures, durable metal structures construction, braga';

  const canonical = isPt ? 'https://metalogic.pt' : 'https://metalogic.pt/en/';

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={keywords} />
      <meta name="title" content={title} />
      <link rel="canonical" hrefLang={isPt ? 'pt' : 'en'} href={canonical} />
      <meta name="author" content="Metalogic" />
      {/* End standard metadata tags */}
      {/* Facebook tags */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content="https://metalogic.pt/" />
      <meta property="og:site_name" content="Metalogic by AR Group" />
      <meta property="og:locale" content={isPt ? 'pt' : 'en'} />
      <meta property="og:image" content="https://metalogic.pt/logo.png" />
      {/* End Facebook tags */}
      {/* Twitter tags */}
      <meta name="twitter:creator" content="Metalogic by AR Group" />
      {/* <meta name="twitter:card" content="summary_large_image" /> */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:site" content="@metalogic" />
      <meta name="twitter:image" content="https://metalogic.pt/logo.png" />
      {/* End Twitter tags */}
      {/* ld+json script  */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "HomeAndConstructionBusiness",
            "name": "Metalogic",
            "url": "https://metalogic.pt",
            "description": "${desc}",
            "logo": "https://metalogic.pt/logo.png",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Rua do Castelo 41",
              "addressLocality": "Braga",
              "postalCode": "4700-311",
              "addressRegion": "Braga",
              "addressCountry": "PT"
            },
            "telephone": "+351253786001",
            "image": ["https://metalogic.pt/logo.png"],
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+351253786001",
              "contactType": "Customer Service",
              "areaServed": "Global",
              "availableLanguage": ["English", "Portuguese"]
            },
            "sameAs": [
              "https://www.facebook.com/ar.group.ar",
              "https://www.linkedin.com/company/ar-group-ar",
              "https://www.instagram.com/group_ar_/"
            ],
            "@graph": [
              {
                "@type": "WebSite",
                "@id": "https://metalogic.pt/#website",
                "url": "https://metalogic.pt/",
                "name": "Metalogic",
                "inLanguage": "pt",
                "potentialAction": {
                  "@type": "SearchAction",
                  "target": "https://metalogic.pt/?s={search_term_string}",
                  "query-input": "required name=search_term_string"
                }
              },
              {
                "@type": "LocalBusiness",
                "@id": "https://metalogic.pt/#localbusiness",
                "name": "Metalogic",
                "image": "https://metalogic.pt/logo.png",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "Rua do Castelo 41",
                  "addressLocality": "Braga",
                  "postalCode": "4700-311",
                  "addressRegion": "Braga",
                  "addressCountry": "PT"
                },
                "telephone": "+351253786001",
                "priceRange": "$$$",
                "openingHoursSpecification": {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                  "opens": "09:00",
                  "closes": "18:00"
                }
              }
            ]
          }
      `}
      </script>
    </Helmet>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export default SEO;
